import React from "react";
import { Accordion } from "@jsq/ds/core";
import * as styles from "../styles_vanilla.css";
import { ConfigFileUploadField } from "./ConfigFileUploadField";
import type { AdvancedPermissionsSectionProps } from "../utils/types";

export const AdvancedPermissionsSection: React.FC<AdvancedPermissionsSectionProps> = ({
  isSubmitting,
  unitsFiles,
  distributionListFiles,
  documentCategoryFiles,
  capitalTransactionTypesFiles,
  distributionTypesFiles,
  netIncomeBasesFiles,
  netIncomeTypesFiles,
  navComponentsFiles,
  entityTypesFiles,
  onUnitsFilesChange,
  onDistributionListFilesChange,
  onDocumentCategoryFilesChange,
  onCapitalTransactionTypesFilesChange,
  onDistributionTypesFilesChange,
  onNetIncomeBasesFilesChange,
  onNetIncomeTypesFilesChange,
  onNavComponentsFilesChange,
  onEntityTypesFilesChange,
  fileUploadKey,
}) => (
  <div className={styles.section}>
    <Accordion
      title="Advanced Arena Configuration"
      startExpanded={false}
      icon="upload"
      data-testid="advanced-permissions-accordion"
    >
      <div className={styles.accordionContent}>
        {/* Section 1: General Configuration Files */}
        <div className={styles.twoColumnGrid}>
          <ConfigFileUploadField
            label="Units CSV File"
            keyPrefix="units"
            description="units configuration"
            onFileSelected={onUnitsFilesChange}
            initialFiles={unitsFiles}
            isDisabled={isSubmitting}
            fileUploadKey={fileUploadKey}
          />

          <ConfigFileUploadField
            label="Distribution List CSV"
            keyPrefix="distribution-list"
            description="distribution list configuration"
            onFileSelected={onDistributionListFilesChange}
            initialFiles={distributionListFiles}
            isDisabled={isSubmitting}
            fileUploadKey={fileUploadKey}
          />

          <ConfigFileUploadField
            label="Document Category CSV"
            keyPrefix="document-category"
            description="document category definitions"
            onFileSelected={onDocumentCategoryFilesChange}
            initialFiles={documentCategoryFiles}
            isDisabled={isSubmitting}
            fileUploadKey={fileUploadKey}
          />

          <ConfigFileUploadField
            label="Entity Types CSV"
            keyPrefix="entity-types"
            description="entity types"
            onFileSelected={onEntityTypesFilesChange}
            initialFiles={entityTypesFiles}
            isDisabled={isSubmitting}
            fileUploadKey={fileUploadKey}
          />
        </div>

        {/* Section Separator */}
        <div className={styles.sectionSeparator} />

        {/* Section 2: Cash Flow Types Configuration Files */}
        <div className={styles.twoColumnGrid}>
          <ConfigFileUploadField
            label="Capital Transaction Types CSV"
            keyPrefix="capital-transaction-types"
            description="capital transaction types"
            onFileSelected={onCapitalTransactionTypesFilesChange}
            initialFiles={capitalTransactionTypesFiles}
            isDisabled={isSubmitting}
            fileUploadKey={fileUploadKey}
          />

          <ConfigFileUploadField
            label="Distribution Types CSV"
            keyPrefix="distribution-types"
            description="distribution types"
            onFileSelected={onDistributionTypesFilesChange}
            initialFiles={distributionTypesFiles}
            isDisabled={isSubmitting}
            fileUploadKey={fileUploadKey}
          />

          <ConfigFileUploadField
            label="Net Income Bases CSV"
            keyPrefix="net-income-bases"
            description="net income bases"
            onFileSelected={onNetIncomeBasesFilesChange}
            initialFiles={netIncomeBasesFiles}
            isDisabled={isSubmitting}
            fileUploadKey={fileUploadKey}
          />

          <ConfigFileUploadField
            label="Net Income Types CSV"
            keyPrefix="net-income-types"
            description="net income types"
            onFileSelected={onNetIncomeTypesFilesChange}
            initialFiles={netIncomeTypesFiles}
            isDisabled={isSubmitting}
            fileUploadKey={fileUploadKey}
          />

          <ConfigFileUploadField
            label="NAV Components CSV"
            keyPrefix="nav-components"
            description="NAV components"
            onFileSelected={onNavComponentsFilesChange}
            initialFiles={navComponentsFiles}
            isDisabled={isSubmitting}
            fileUploadKey={fileUploadKey}
          />
        </div>
      </div>
    </Accordion>
  </div>
);
